<template>
    <div class="page" ref="scroller">
        <div class="list">
            <div
                class="item"
                :class="{ nocanUse: !item.canUse }"
                v-for="item in list"
                :key="item.id"
                @click="goSearch(item)"
            >
                <div class="header">
                    <div class="left">
                        <div class="title">
                            {{ item.title }}
                        </div>
                        <div class="mark">
                            {{
                                item.youhuiType == "XIANJIN"
                                    ? "现金券"
                                    : "满减券"
                            }}
                        </div>
                        <div class="time" :class="{ hide: !item.useEnd }">
                            有效期至{{ item.useEnd }}
                        </div>
                    </div>
                    <div class="right">
                        <span>￥</span>
                        <span>
                            {{
                                item.youhuiType == "XIANJIN"
                                    ? item.xianjin
                                    : item.manjianConfig.jian
                            }}
                        </span>
                        <div class="ky">
                            {{
                                item.youhuiType == "XIANJIN"
                                    ? "无金额门槛"
                                    : `满${item.manjianConfig.man}可用`
                            }}
                        </div>
                    </div>
                </div>
                <div class="line"></div>
                <div class="footer">
                    <span>{{ item.instruction }}</span>
                    <div v-if="item.canUse" class="btn">
                        立即使用
                    </div>
                    <div class="notUserMsg" v-else>{{ item.notUserMsg }}</div>
                </div>
            </div>
        </div>
        <no-content :msg="'暂无优惠券'" v-if="showNoContent"></no-content>
    </div>
</template>

<script>
    import userCenterService from "../../service/user-center.service";
    import scrollerMixin from "../../scroller.mixin";
    import noContent from "../../components/no-content/no-content";
    export default {
        name: "coupon-list",
        mixins: [scrollerMixin],
        components: {
            "no-content": noContent,
        },
        data() {
            return {
                list: [],
                showNoContent: false,
            };
        },
        mounted() {
            this.getMyCouponList();
        },
        methods: {
            getMyCouponList() {
                userCenterService.getMyCouponList().then((res) => {
                    this.list = res.data;
                    if (this.list.length <= 0) {
                        this.showNoContent = true;
                    }
                });
            },
            goSearch(obj) {
                if (!obj.canUse) {
                    return;
                }
                this.$router.push("/index");
            },
        },
    };
</script>

<style lang="scss" scoped src="./coupon-list.scss"></style>
